// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_80mm_80mm_1_label_layout__1SaCQ"};